import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35359432"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tariff" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_4 = { class: "flex items-center justify-end mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_table = _resolveComponent("the-table")!
  const _component_table_scroll_wrapper = _resolveComponent("table-scroll-wrapper")!
  const _component_the_select = _resolveComponent("the-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: _ctx.title }, null, 8, ["title"]),
      _createVNode(_component_the_button, {
        class: "second small text",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(" Назад ")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("form", {
      class: "mt-6",
      onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
    }, [
      (_ctx.state.shipmentCosts)
        ? (_openBlock(), _createBlock(_component_table_scroll_wrapper, {
            key: 0,
            loading: _ctx.state.is_loading
          }, {
            default: _withCtx(() => [
              _createVNode(_component_the_table, {
                loading: _ctx.state.is_loading,
                columns: _ctx.IndividualTariffsMain,
                rows: _ctx.IndividualTariffs
              }, {
                td: _withCtx(({ row, column, key }) => [
                  (column.key === 'weight')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(row.weight), 1)
                      ], 64))
                    : (row.is_title)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(row.titles[_ctx.getIndexTitle(key)]), 1)
                        ], 64))
                      : (_openBlock(), _createBlock(_component_the_input, {
                          key: 2,
                          value: _ctx.state.shipmentCosts[_ctx.getIndex(key)].minPrice,
                          "onUpdate:value": ($event: any) => ((_ctx.state.shipmentCosts[_ctx.getIndex(key)].minPrice) = $event),
                          placeholder: _ctx.getPlaceholder(_ctx.getIndex(key), column.typeId),
                          "is-invalid": 
                                    _ctx.state_form$.shipmentCosts.$each?.$response?.$data[_ctx.getIndex(key)]
                                        ?.minPrice?.$invalid
                                
                        }, null, 8, ["value", "onUpdate:value", "placeholder", "is-invalid"]))
                ]),
                _: 1
              }, 8, ["loading", "columns", "rows"])
            ]),
            _: 1
          }, 8, ["loading"]))
        : _createCommentVNode("", true),
      (_ctx.state.shipmentCosts)
        ? (_openBlock(), _createBlock(_component_table_scroll_wrapper, {
            key: 1,
            loading: _ctx.state.is_loading
          }, {
            default: _withCtx(() => [
              _createVNode(_component_the_table, {
                loading: _ctx.state.is_loading,
                columns: _ctx.StandardParamsColumns,
                rows: _ctx.StandardParamsRows
              }, {
                td: _withCtx(({ row, column, key }) => [
                  (column.key === 'description')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (row.name === 'packPrice')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(" Терминальная обработка (₸) ")
                            ], 64))
                          : (row.name === 'orderPrice')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(" Сбор за оформление заказа (₸) ")
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createTextVNode(_toDisplayString(`${row.description} ${_ctx.getSign(row.name)}`), 1)
                              ], 64))
                      ], 64))
                    : (row.name === 'overloadWeight')
                      ? (_openBlock(), _createBlock(_component_the_select, {
                          key: 1,
                          value: _ctx.state.standardParams[_ctx.getParamsIndex(key, 13)].amount,
                          "onUpdate:value": ($event: any) => ((_ctx.state.standardParams[_ctx.getParamsIndex(key, 13)].amount) = $event),
                          placeholder: "Количество",
                          options: _ctx.OVERLOAD_WEIGHT_TYPES,
                          onChange: (value) => _ctx.onOverloadChange(value, column.typeId)
                        }, null, 8, ["value", "onUpdate:value", "options", "onChange"]))
                      : (_openBlock(), _createBlock(_component_the_input, {
                          key: 2,
                          value: _ctx.state.standardParams[_ctx.getParamsIndex(key, 13)].amount,
                          "onUpdate:value": ($event: any) => ((_ctx.state.standardParams[_ctx.getParamsIndex(key, 13)].amount) = $event),
                          "is-invalid": 
                                    _ctx.state_form$.standardParams.$each?.$response?.$data[
                                        _ctx.getParamsIndex(key, 13)
                                    ]?.amount?.$invalid
                                ,
                          placeholder: "Количество",
                          onInput: ($event: any) => (_ctx.onParamsInput(_ctx.getParamsIndex(key, 13)))
                        }, null, 8, ["value", "onUpdate:value", "is-invalid", "onInput"]))
                ]),
                _: 1
              }, 8, ["loading", "columns", "rows"])
            ]),
            _: 1
          }, 8, ["loading"]))
        : _createCommentVNode("", true),
      _createVNode(_component_table_scroll_wrapper, {
        loading: _ctx.state.is_loading
      }, {
        default: _withCtx(() => [
          _createVNode(_component_the_table, {
            loading: _ctx.state.is_loading,
            columns: _ctx.AdditionalServicesColumns,
            rows: _ctx.state.additionalServices
          }, {
            td: _withCtx(({ row, column, key }) => [
              (column.key === 'name')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.AdditionalServicesEnum[row.name]), 1)
                  ], 64))
                : (column.key === 'price')
                  ? (_openBlock(), _createBlock(_component_the_input, {
                      key: 1,
                      value: row.price,
                      "onUpdate:value": ($event: any) => ((row.price) = $event),
                      "is-invalid": 
                                    _ctx.state_form$.additionalServices.$each?.$response?.$data[
                                        _ctx.getRowIndex(key)
                                    ]?.price?.$invalid
                                ,
                      placeholder: "Цена"
                    }, null, 8, ["value", "onUpdate:value", "is-invalid"]))
                  : (_openBlock(), _createBlock(_component_the_input, {
                      key: 2,
                      value: row.minValue,
                      "onUpdate:value": ($event: any) => ((row.minValue) = $event),
                      placeholder: "Мин. значение"
                    }, null, 8, ["value", "onUpdate:value"]))
            ]),
            _: 1
          }, 8, ["loading", "columns", "rows"])
        ]),
        _: 1
      }, 8, ["loading"]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_the_button, {
          type: "submit",
          class: "primary small",
          loading: _ctx.state.is_loading
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Редактировать ")
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ], 32)
  ]))
}